/* eslint-disable @typescript-eslint/no-explicit-any */
import { CenterProps } from '@chakra-ui/react';
import React, { PropsWithRef, Suspense } from 'react';
import { CenterSpinner } from '~/common/components/CenterSpinner';

export const withLazyComponent = function <T>(
  Component: React.LazyExoticComponent<React.FC<T>>,
  spinnerContainerProps?: CenterProps
) {
  return (props: JSX.IntrinsicAttributes & PropsWithRef<T>) => (
    <Suspense
      fallback={<CenterSpinner containerProps={spinnerContainerProps} />}
    >
      <Component {...props} />
    </Suspense>
  );
};
